"use client";
// @ts-strict-ignore
import type {
  CryptopediaCategoryType,
  CryptopediaTopicType
} from "types/cryptopedia";
import type { TableOfContents as TableOfContentsType } from "utils/tableOfContents";
import { useScrollSpyOnUpdate } from "utils/scrollSpyUpdate";
import {
  ContentItem,
  ContentList,
  Title
} from "components/pages/Cryptopedia/FloatingTableOfContents/style";
import { FontSize } from "components/parts/Typography";
import React from "react";
import Scrollspy from "react-scrollspy";
import scrollToElement from "utils/scrollToElement";

interface FloatingTableOfContentsProps {
  topics: Array<CryptopediaTopicType>;
  mainCategory: CryptopediaCategoryType;
  title: string;
  contents: TableOfContentsType[];
}

const FloatingTableOfContents = ({
  contents
}: FloatingTableOfContentsProps) => {
  const { scrollSpyUpdate, currentAnchor } = useScrollSpyOnUpdate({
    initialState: "",
    debounceDelay: 250,
    querySelector: ".anchor-active a"
  });

  if (!contents.length) {
    return null;
  }

  const scrollSpyItems = contents.map(({ url }) => url.substring(1));

  return (
    <ContentList visible>
      <Title bold lg={{ fontSize: FontSize.px14 }}>
        Contents
      </Title>
      <Scrollspy
        items={scrollSpyItems}
        currentClassName="anchor-active"
        onUpdate={scrollSpyUpdate}
      >
        {contents.map((content) => (
          <li
            key={content.url}
            onClick={(e) => {
              e.preventDefault();
              scrollToElement(content.url, -1);
            }}
          >
            <a href={content.url}>
              <ContentItem
                lg={{ fontSize: FontSize.px12 }}
                color={currentAnchor === content.url ? "primary" : "secondary"}
              >
                {content.anchor}
              </ContentItem>
            </a>
          </li>
        ))}
      </Scrollspy>
    </ContentList>
  );
};

export default FloatingTableOfContents;
